module.exports = __webpack_public_path__ + "img/StaticAlarm.9c4aef4d.svg";